import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { BulkRecruiter } from '../model/recruiter.model';
import { RecruiterServices } from '../../shared/services/recruiter.services';
import { MatSidenav } from '@angular/material/sidenav';

import { Angular2CsvModule } from 'angular2-csv';



@Component({
  selector: 'app-bulk-recruiter',
  templateUrl: './bulk-recruiter.component.html',
  styleUrls: ['./bulk-recruiter.component.scss']
})
export class BulkRecruiterComponent {
  @Input() inputSideNav: MatSidenav;
  @Output() close: EventEmitter<any> = new EventEmitter();

  @ViewChild('divClick', {static: false}) divClick: ElementRef;


  fileSelectMsg: string = 'No file selected yet.';
  fileUploadMsg: string = 'No file uploaded yet.';
  disabled: boolean = false;
  csvFile: any = '';
  fileError: any = '';
  fileErrorFlag: boolean = true;
  csv: BulkRecruiter;
  formStatus = false;
  statusClass: string;
  responseMessage: string;
  responseIcon: string;
  active = true;
  closeF: any;
  public downloaddata: any = [];
  public downloadhide: boolean = false;

  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    headers: ['Phone', 'access_code', 'employee_id', 'location', 'country', 'recruiter_name', 'remarks', 'status'],
    showTitle: false,
    title: '',
    useBom: true,
    removeNewLines: true,
    keys: ['Phone', 'access_code', 'employee_id', 'location', 'country', 'recruiter_name', 'remarks', 'status']
  };

  constructor(private recruiter: RecruiterServices) { }

  onFileChanged(event) {
    this.csvFile = event.target.files[0];
    if (this.csvFile.type == 'text/csv' || this.csvFile.type == "application/vnd.ms-excel") {
      this.fileErrorFlag = true;
      this.fileSelectMsg = this.csvFile.name;
    }
    else {
      this.fileError = `This file format can't be upload. Please use csv file format`;
      this.fileSelectMsg = this.csvFile.name;
      this.fileErrorFlag = false;
    }
  }

  onSave() {
    this.recruiter.bulkUploadRecruiter(this.csvFile).subscribe(data => {
      if (data.responseCode == 1) {
        this.formStatus = true;
        this.statusClass = 'success';
        this.responseIcon = 'check_circle_outline';
        this.responseMessage = 'Your file has been uploaded successfully.';
        this.downloadhide = true;
        this.downloaddata = data.finalResult;
        setTimeout(() => {
          this.formStatus = false;
        }, 5000);
      } else {
        this.formStatus = true;
        this.statusClass = 'fail';
        this.responseIcon = 'error_outline';
        this.responseMessage = 'Oops ! Error';
      }
    });
  }

  onClose() {
    this.inputSideNav.toggle();
    //this.close.emit();
  }

  removedSuccessMsg() {
    setTimeout(() => {
      this.downloadhide = false;
    }, 1000);
  }

}
